import { useEffect } from 'react';
import type React from 'react';

import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from '@change/ds-core-ui';

import {
	useReadyToShareContext,
	useSharingModal as useSharingModalContext,
} from 'src/app/pages/starterDashboardV2/shared/contexts';

import { useSharingModal } from './hooks/useSharingModal';
import type { SharingModalProps } from './types';

export const SharingModal: React.FC<SharingModalProps> = (props) => {
	const { stopSharingFlow } = useSharingModalContext();
	const {
		data: { platformData },
	} = useReadyToShareContext();

	const {
		data: {
			modalTitle,
			modalDescription,
			primaryCTA,
			secondaryCTA,
			iconComponent,
			nextStepsComponent,
			postPreviewComponent,
		},
		actions: { primaryAction, secondaryAction, trackView },
	} = useSharingModal(props, platformData);

	const { defaultOpen } = props;

	useEffect(() => {
		if (defaultOpen) trackView();
	}, [defaultOpen, trackView]);

	return (
		<Modal
			defaultOpen={defaultOpen}
			isDismissable
			onClose={stopSharingFlow}
			data-testid="sharing-modal"
			size="large"
			className="z-30 md:[&>div>div]:max-h-[750px]!"
			onOpenChange={(isOpen) => {
				if (!isOpen) {
					stopSharingFlow();
				}
			}}
		>
			<ModalHeader title={modalTitle} subtitle={modalDescription} leadingSlot={iconComponent()} />
			<ModalBody className="pt-2">
				<div className="flex w-full flex-col gap-6 md:flex-row md:gap-8">
					<div className="flex-1">{postPreviewComponent()}</div>
					<div className="flex-1">{nextStepsComponent()}</div>
				</div>
			</ModalBody>
			<ModalFooter>
				<Button
					onClick={primaryAction}
					variant="primary"
					data-testid="primary-action"
					data-qa="sharing-modal-primary-action"
				>
					{primaryCTA}
				</Button>
				{secondaryAction && (
					<Button onClick={secondaryAction} data-testid="secondary-action" data-qa="sharing-modal-secondary-action">
						{secondaryCTA}
					</Button>
				)}
			</ModalFooter>
		</Modal>
	);
};
